(function() {
  const seeMoreLessBtns = document.querySelectorAll('.see-more-less');

  if (seeMoreLessBtns.length === 0) return;

  seeMoreLessBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const wrapper = e.currentTarget.closest('.with-see-more-less');
      const content = wrapper?.querySelector('.see-more-less-content');

      if (!wrapper || !content) return;

      wrapper.classList.toggle('active');
      
      if (wrapper.classList.contains('active')) {
        content.style.maxHeight = content.firstElementChild.offsetHeight + 'px';
      } else {
        content.style.removeProperty("max-height");
      }
    });
  });

  window.addEventListener('resize', () => {
    seeMoreLessBtns.forEach((btn) => {
      const wrapper = btn.closest('.with-see-more-less');
      const content = wrapper?.querySelector('.see-more-less-content');

      if (!wrapper || !content) return;
      
      if (wrapper.classList.contains('active')) {
        content.style.maxHeight = content.firstElementChild.offsetHeight + 'px';
      } else {
        content.style.removeProperty('max-height');
      }
    });
  });
})();